import clsx from 'clsx';
import { useState } from 'react';
import BlockPalette from './BlockPalette.jsx';
import LayersPanel from './LayersPanel.jsx';

const TABS = [
  { id: 'blocks', label: 'Blocks', icon: '◇' },
  { id: 'layers', label: 'Layers', icon: '☰' },
];

export default function LeftSidebar() {
  const [tab, setTab] = useState('blocks');

  return (
    <aside className="flex h-full w-64 shrink-0 flex-col border-r border-ink-200 bg-white dark:border-ink-800 dark:bg-ink-900">
      <div className="flex border-b border-ink-200 dark:border-ink-800">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={clsx(
              'flex flex-1 items-center justify-center gap-1.5 py-2.5 text-xs font-semibold transition',
              tab === t.id
                ? 'border-b-2 border-brand-500 text-brand-700'
                : 'text-ink-500 hover:bg-ink-50 dark:hover:bg-ink-800',
            )}
          >
            <span aria-hidden>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>
      <div className="scroll-pane flex-1 overflow-y-auto">
        {tab === 'blocks' ? <BlockPalette /> : <LayersPanel />}
      </div>
    </aside>
  );
}
